// Mock data for Sweet Life landing page

export const navLinks = [
  { name: 'Home', href: '/' },
  { name: 'About Us', href: '/about-us' },
  { name: 'Our Products', href: '/our-products' },
  { name: 'Private Label', href: '/customize' },
  { name: 'Online Store', href: 'https://www.balasdingo.com.br/', external: true },
  { name: 'Catalog', href: '/catalog' },
  { name: 'Contact', href: '/contact' }
];

export const latasMentolados = [
  {
    id: 1,
    name: 'MINT',
    image: 'https://www.sweetlife.com.br/images/balas/bala-hortela.png'
  },
  {
    id: 2,
    name: 'EXTRA STRONG',
    image: 'https://www.sweetlife.com.br/images/balas/extra-forte.png'
  },
  {
    id: 3,
    name: 'RED BERRIES',
    image: 'https://www.sweetlife.com.br/images/balas/bala-frutas-vermelhas.png'
  },
  {
    id: 4,
    name: 'CHERRY',
    image: 'https://www.sweetlife.com.br/images/balas/bala-cereja.png'
  },
  {
    id: 5,
    name: 'DISPLAY OF 10 UNITS',
    image: 'https://www.sweetlife.com.br/images/balas/bala-display.png'
  }
];

export const latasSabores = [
  {
    id: 6,
    name: 'COFFEE',
    image: 'https://www.sweetlife.com.br/images/balas/bala-cafe.png'
  },
  {
    id: 7,
    name: 'TROPICAL FRUITS',
    image: 'https://www.sweetlife.com.br/images/balas/bala-mista.png'
  },
  {
    id: 8,
    name: 'PASSION FRUIT',
    image: 'https://www.sweetlife.com.br/images/balas/bala-maracuja.png'
  },
  {
    id: 9,
    name: 'STRAWBERRY',
    image: 'https://www.sweetlife.com.br/images/balas/bala-morango.png'
  },
  {
    id: 10,
    name: 'GINGER',
    image: 'https://www.sweetlife.com.br/images/balas/bala-gengibre.png'
  },
  {
    id: 11,
    name: 'TANGERINE',
    image: 'https://www.sweetlife.com.br/images/balas/bala-tangerina.png'
  }
];

export const saches16g = [
  { id: 1, name: 'tangerine', image: 'https://www.sweetlife.com.br/images/balas/sache-16/tangerina.png' },
  { id: 2, name: 'pineapple', image: 'https://www.sweetlife.com.br/images/balas/sache-16/abacaxi.png' },
  { id: 3, name: 'strawberry', image: 'https://www.sweetlife.com.br/images/balas/sache-16/morango.png' },
  { id: 4, name: 'lemon', image: 'https://www.sweetlife.com.br/images/balas/sache-16/limao.png' },
  { id: 5, name: 'orange', image: 'https://www.sweetlife.com.br/images/balas/sache-16/laranja.png' },
  { id: 6, name: 'grape', image: 'https://www.sweetlife.com.br/images/balas/sache-16/uva.png' }
];

export const saches18g = [
  { id: 1, name: 'ginger', image: 'https://www.sweetlife.com.br/images/balas/sache-18/gengibre.png' },
  { id: 2, name: 'cinnamon', image: 'https://www.sweetlife.com.br/images/balas/sache-18/canela.png' },
  { id: 3, name: 'coffee', image: 'https://www.sweetlife.com.br/images/balas/sache-18/cafe.png' }
];

export const saches20g = [
  { id: 1, name: 'coffee', image: 'https://www.sweetlife.com.br/images/balas/sache-20/cafe.jpg' },
  { id: 2, name: 'cherry', image: 'https://www.sweetlife.com.br/images/balas/sache-20/cereja.jpg' },
  { id: 3, name: 'red berries', image: 'https://www.sweetlife.com.br/images/balas/sache-20/frutas-vermelhas.jpg' },
  { id: 4, name: 'tropical fruits', image: 'https://www.sweetlife.com.br/images/balas/sache-20/frutas-tropicais.jpg' },
  { id: 5, name: 'extra strong', image: 'https://www.sweetlife.com.br/images/balas/sache-20/extra-forte.jpg' },
  { id: 6, name: 'ginger', image: 'https://www.sweetlife.com.br/images/balas/sache-20/gengibre.jpg' },
  { id: 7, name: 'mint', image: 'https://www.sweetlife.com.br/images/balas/sache-20/hortela.jpg' },
  { id: 8, name: 'passion fruit', image: 'https://www.sweetlife.com.br/images/balas/sache-20/maracuja.jpg' },
  { id: 9, name: 'strawberry', image: 'https://www.sweetlife.com.br/images/balas/sache-20/morango.jpg' },
  { id: 10, name: 'tangerine', image: 'https://www.sweetlife.com.br/images/balas/sache-20/tangerina.jpg' }
];

export const saches100g = [
  { id: 1, name: 'coffee', image: 'https://www.sweetlife.com.br/images/balas/sache-100/cafe.png' },
  { id: 2, name: 'tropical fruits', image: 'https://www.sweetlife.com.br/images/balas/sache-100/frutas-tropicais.png' },
  { id: 3, name: 'mint', image: 'https://www.sweetlife.com.br/images/balas/sache-100/hortela.png' },
  { id: 4, name: 'passion fruit', image: 'https://www.sweetlife.com.br/images/balas/sache-100/maracuja.png' },
  { id: 5, name: 'strawberry', image: 'https://www.sweetlife.com.br/images/balas/sache-100/morango.png' }
];

export const granelMentolados = [
  'CHERRY',
  'RED BERRIES',
  'MINT'
];

export const granelSabores = [
  'COFFEE',
  'GINGER',
  'PASSION FRUIT',
  'TROPICAL FRUITS',
  'STRAWBERRY',
  'TANGERINE'
];

export const languages = [
  { code: 'br', name: 'Brasil', flag: 'https://flagdownload.com/wp-content/uploads/Flag_of_Brazil-1024x716.png' },
  { code: 'en', name: 'English', flag: 'https://flagdownload.com/wp-content/uploads/Flag_of_United_Kingdom-1024x512.png' },
  { code: 'py', name: 'Paraguay', flag: 'https://flagdownload.com/wp-content/uploads/Flag_of_Paraguay-1024x563.png' },
  { code: 'ar', name: 'العربية', flag: 'https://flagdownload.com/wp-content/uploads/Flag_of_United_Arab_Emirates-1024x512.png' },
  { code: 'cn', name: '中国', flag: 'https://flagdownload.com/wp-content/uploads/Flag_of_Peoples_Republic_of_China-1024x683.png' }
];
